/**
 * Labstep
 *
 * @module components/EntityUserRoleRequirement/Form/ShowEdit/EntityUserRole
 * @desc   Select EntityUserRole for EntityUserRoleRequirement
 */

import { ENTITY_USER_ROLE_OPTIONS_GROUPS } from 'labstep-web/components/EntityUserRole/Form/fields';
import { EntityUserRoleSelectPanel } from 'labstep-web/components/EntityUserRole/SelectPanel';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { EntityUserRoleRequirement } from 'labstep-web/models/entity-user-role-requirement.model';
import type { Group } from 'labstep-web/models/group.model';
import type React from 'react';
import type { EntityUserRoleRequirementFormShowEditEntityUserRoleProps } from './types';

export const EntityUserRoleRequirementFormShowEditEntityUserRole: React.FC<
  EntityUserRoleRequirementFormShowEditEntityUserRoleProps
> = ({ activeGroup, entityUserRoleRequirement }) => {
  return (
    <EntityUpdateContainer
      entityName={EntityUserRoleRequirement.entityName}
      id={entityUserRoleRequirement.id}
    >
      {({ update }) => (
        <EntityUserRoleSelectPanel
          systemOptions={ENTITY_USER_ROLE_OPTIONS_GROUPS}
          group={activeGroup as Group}
          onBlur={() => {}}
          onChange={(entityUserRole) => {
            if (entityUserRole) {
              update({
                entity_user_role_id: entityUserRole.id,
                number_required: 1,
              });
            }
          }}
          entityType="Role"
          defaultSelectedRoleId={
            entityUserRoleRequirement.entity_user_role.id
          }
          openMenuOnFocus={false}
        />
      )}
    </EntityUpdateContainer>
  );
};

export default withActiveGroup(
  EntityUserRoleRequirementFormShowEditEntityUserRole,
);
